<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EfBwZx/tc-custom/9781137431332.jpg?1737764884420" alt="This image is the cover for the book The Safe Investor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Safe Investor
      </h1>
      <p class="bookDescription body article font2">
        <p>Investing information  is everywhere; there are blogs, newspapers, magazines, and cable TV shows all dedicated to helping individuals invest in smarter and more successful ways. Yet despite all the efforts to educate the public on investing, most people still feel uncomfortable  with how they should actually invest their money. Recent predictions about slowing economic growth, historically low interest rates, and volatile markets have investors scratching their heads about what to do with their money. And more than ever, people are scared about whether they can grow their money enough to last through their lifetime.<br/>Expert investor Timothy McCarthy  has spent the last 30 years in the US and overseas providing investment solutions to individuals and their advisors. He believes that  understanding  how to create  a  truly globally  diverse portfolio while applying the magic of time will help all investors navigate risky markets. McCarthy  also explores the fundamentals of picking and evaluating financial advisors for those who want to understand the principles of investing but not actually do the work themselves. McCarthy  helps guide the reader along a straightforward  path to investment  success by telling engaging and actual stories to illustrate each of his seven lessons of successful investing. The Safe Investor will help even those readers with little interest or aptitude for finance to be comfortable in knowing what to do to manage their life investment plan and how to manage their own advisors.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Timothy F. McCarthy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b51318de